/* PP-New-sept26-OS · theme behaviours. Every block is scoped to the section it finds, so repeated sections work. */
(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const S = (window.PP && window.PP.settings) || {};
  const R = S.routes || { cart: '/cart', add: '/cart/add', change: '/cart/change', root: '/' };
  const pad = n => String(n).padStart(2, '0');
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  /* ---------- money (paise in, shop format out) ---------- */
  const money = cents => {
    const fmt = S.moneyFormat || '₹{{amount_no_decimals}}';
    const v = (cents || 0) / 100;
    const withSep = (n, d) => n.toFixed(d).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      if (k === 'amount_no_decimals' || k === 'amount_no_decimals_with_comma_separator') return withSep(Math.round(v), 0);
      if (k === 'amount') return v % 1 ? withSep(v, 2) : withSep(v, 0);
      return withSep(v, 2);
    }).replace(/<[^>]*>/g, '');
  };

  /* ---------- toast ---------- */
  let tt;
  const say = m => {
    const t = $('#toast'); if (!t) return;
    t.textContent = m; t.classList.add('show'); clearTimeout(tt);
    tt = setTimeout(() => t.classList.remove('show'), 2400);
  };

  /* ---------- overlays: menu, search, bag ---------- */
  let scrim = null, opener = null, openEl = null;
  const lock = on => { document.body.style.overflow = on ? 'hidden' : ''; };
  function close() {
    if (!openEl) return;
    openEl.hidden = true; openEl = null; lock(false);
    if (scrim) { scrim.remove(); scrim = null; }
    $$('.js-menu, .js-search').forEach(b => b.setAttribute('aria-expanded', 'false'));
    if (opener && opener.focus) opener.focus();
  }
  const open = (el, focus) => {
    if (!el) return;
    close(); openEl = el; opener = document.activeElement; el.hidden = false; lock(true);
    if (el.id !== 'menu') { scrim = document.createElement('div'); scrim.className = 'scrim'; scrim.addEventListener('click', close); document.body.appendChild(scrim); }
    const f = focus || el.querySelector('button, a, input'); if (f) f.focus();
  };
  const openDrawer = () => open($('#drawer'));

  document.addEventListener('click', e => {
    const t = e.target;
    const m = t.closest('.js-menu');
    if (m) { open($('#menu'), $('#menuClose')); m.setAttribute('aria-expanded', 'true'); return; }
    const s = t.closest('.js-search');
    if (s) { open($('#srch'), $('#q')); s.setAttribute('aria-expanded', 'true'); return; }
    if (t.closest('.js-bag')) { if (document.body.dataset.page !== 'cart') { e.preventDefault(); openDrawer(); } return; }
    if (t.closest('#menuClose, .js-search-close, .js-drawer-close')) { close(); return; }
    if (t.closest('#menu nav a')) { opener = null; close(); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });

  /* ---------- cart (AJAX + section rendering) ---------- */
  const setCount = n => {
    $$('.bag-count').forEach(b => { b.textContent = n; b.classList.add('bump'); setTimeout(() => b.classList.remove('bump'), 300); });
    $$('.js-bag').forEach(b => b.setAttribute('aria-label', `Bag, ${n} item${n === 1 ? '' : 's'}`));
  };
  const swapDrawer = html => {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('#drawer'), cur = $('#drawer');
    if (!fresh || !cur) return;
    cur.innerHTML = fresh.innerHTML;
    cur.dataset.count = fresh.dataset.count;
    setCount(+fresh.dataset.count || 0);
  };
  const cartJSON = () => fetch(R.root.replace(/\/?$/, '/') + 'cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
  const emit = () => cartJSON().then(c => document.dispatchEvent(new CustomEvent('pp:cart', { detail: c }))).catch(() => {});
  const post = (url, body) => fetch(url + '.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(Object.assign({ sections: 'cart-drawer', sections_url: location.pathname }, body))
  }).then(r => r.json().then(j => { if (!r.ok) throw j; return j; }));

  const addItem = (id, quantity = 1, props, btn) => {
    if (!id) return Promise.resolve();
    if (btn) btn.setAttribute('aria-busy', 'true');
    /* A comma-separated id list (combo cards) adds every item in one request */
    const body = { items: String(id).split(',').filter(Boolean).map(i => ({ id: +i, quantity: +quantity, properties: props || {} })) };
    return post(R.add, body).then(j => {
      swapDrawer(j.sections && j.sections['cart-drawer']);
      emit();
      if (document.body.dataset.page === 'cart') { location.reload(); return; }
      openDrawer();
    }).catch(err => say((err && (err.description || err.message)) || 'Could not add that to your bag. Please try again.'))
      .finally(() => { if (btn) btn.removeAttribute('aria-busy'); });
  };
  const changeLine = (line, quantity) => post(R.change, { line: +line, quantity: +quantity }).then(j => {
    if (document.body.dataset.page === 'cart') { location.reload(); return; }
    swapDrawer(j.sections && j.sections['cart-drawer']);
    emit();
  }).catch(err => say((err && err.description) || 'Could not update your bag.'));

  document.addEventListener('click', e => {
    const a = e.target.closest('[data-add-variant]');
    if (a) {
      e.preventDefault();
      if (a.getAttribute('aria-disabled') === 'true') return;
      /* Checked [data-prop] boxes in the same card become line-item properties */
      const scope = a.closest('[data-add-scope]');
      let props = null;
      if (scope) $$('input[data-prop]:checked', scope).forEach(i => { (props = props || {})[i.dataset.prop] = i.value; });
      addItem(a.dataset.addVariant, a.dataset.qty || 1, props, a);
      return;
    }
    const l = e.target.closest('[data-line][data-qty]');
    if (l) { e.preventDefault(); changeLine(l.dataset.line, Math.max(0, +l.dataset.qty)); }
  });
  document.addEventListener('submit', e => {
    const f = e.target.closest('form.js-add-form');
    if (!f) return;
    e.preventDefault();
    const fd = new FormData(f), props = {};
    fd.forEach((v, k) => { const m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; });
    addItem(fd.get('id'), fd.get('quantity') || 1, props, f.querySelector('[type=submit]'));
  });

  /* ---------- checkout: Shiprocket (snippets/sr-checkout.liquid) when its script has loaded, else Shopify ---------- */
  const sr = () => window.shiprocketCheckoutEvents;
  document.addEventListener('click', e => {
    const b = e.target.closest('.js-checkout'); if (!b) return;
    e.preventDefault();
    const go = sr() ? () => { close(); sr().buyCart(); } : () => { location.href = R.root.replace(/\/?$/, '/') + 'checkout'; };
    /* Shiprocket reads /cart.js, so save the cart page's order note first */
    const note = $('#cart-note');
    if (!note) { go(); return; }
    b.setAttribute('aria-busy', 'true');
    fetch(R.root.replace(/\/?$/, '/') + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: note.value })
    }).catch(() => {}).finally(() => { b.removeAttribute('aria-busy'); go(); });
  });

  /* ---------- header: transparent over the hero, solid after ---------- */
  const initHeader = () => {
    const hdr = $('#hdr'); if (!hdr) return;
    const over = $('[data-over]');
    if (document.body.dataset.hdr === 'over' && over && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => hdr.classList.toggle('stuck', !e.isIntersecting), { rootMargin: '-72px 0px 0px 0px' }).observe(over);
    } else { hdr.classList.add('stuck'); delete document.body.dataset.hdr; }
  };

  /* ---------- details: one open at a time within the same parent ---------- */
  document.addEventListener('toggle', e => {
    const d = e.target;
    if (!(d instanceof HTMLDetailsElement) || !d.open || !d.matches('.qa[data-one]')) return;
    $$(':scope > .qa[data-one]', d.parentElement).forEach(o => { if (o !== d) o.open = false; });
  }, true);

  /* ---------- certificate images: hide the drawn fallback once the scan loads ---------- */
  const certs = (root = document) => $$('img[data-cert]', root).forEach(img => {
    const ok = () => img.parentElement.classList.add('has-img');
    if (img.complete && img.naturalWidth) ok(); else img.addEventListener('load', ok, { once: true });
  });

  /* ---------- generic tabs (role=tablist, aria-controls) ---------- */
  const tabs = root => $$('[role=tablist][data-tabs]', root).forEach(list => {
    const ts = $$('[role=tab]', list);
    const pick = (i, focus) => ts.forEach((t, n) => {
      const on = n === i;
      t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1;
      const p = document.getElementById(t.getAttribute('aria-controls')); if (p) p.hidden = !on;
      if (on && focus) t.focus();
    });
    ts.forEach((t, i) => {
      t.addEventListener('click', () => pick(i));
      t.addEventListener('keydown', e => {
        const map = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: ts.length - 1 };
        if (!(e.key in map)) return;
        e.preventDefault(); pick((map[e.key] + ts.length) % ts.length, true);
      });
    });
  });

  /* ---------- hero slideshow ---------- */
  const slideshow = hero => {
    if (hero.dataset.ready) return; hero.dataset.ready = 1;
    const slides = $$('.slide', hero); if (!slides.length) return;
    const pin = parseInt(new URLSearchParams(location.search).get('slide'), 10);
    const DUR = (+hero.dataset.duration || 6.5) * 1000;
    const still = pin > 0 || hero.dataset.autoplay === 'false' || matchMedia('(prefers-reduced-motion: reduce)').matches || window.Shopify && Shopify.designMode;
    let cur = 0, timer = 0, visible = true;
    hero.style.setProperty('--dur', DUR + 'ms');
    const dotsBox = $('.hs-dots', hero), count = $('.hs-count', hero);
    if (dotsBox) dotsBox.innerHTML = slides.map((_, i) => `<button type="button" aria-label="Go to slide ${i + 1}"><i></i></button>`).join('');
    const dots = dotsBox ? $$('button', dotsBox) : [];
    const nav = $('.hs-nav', hero); if (nav) nav.hidden = slides.length < 2;
    const go = n => {
      cur = (n + slides.length) % slides.length;
      slides.forEach((s, i) => { s.classList.toggle('on', i === cur); s.inert = i !== cur; });
      dots.forEach((d, i) => { d.removeAttribute('aria-current'); if (i === cur) { void d.offsetWidth; d.setAttribute('aria-current', 'true'); } });
      if (count) count.textContent = `${pad(cur + 1)} / ${pad(slides.length)}`;
      $$('img', slides[cur]).forEach(im => { im.loading = 'eager'; });
      play();
    };
    const stop = () => { clearTimeout(timer); hero.classList.add('paused'); };
    function play() {
      clearTimeout(timer);
      if (still || slides.length < 2 || !visible || hero.matches(':hover, :focus-within')) return stop();
      hero.classList.remove('paused'); timer = setTimeout(() => go(cur + 1), DUR);
    }
    dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
    const pv = $('.arr.prev', hero), nx = $('.arr.next', hero);
    if (pv) pv.addEventListener('click', () => go(cur - 1));
    if (nx) nx.addEventListener('click', () => go(cur + 1));
    hero.addEventListener('mouseenter', stop); hero.addEventListener('mouseleave', play);
    hero.addEventListener('focusin', stop); hero.addEventListener('focusout', () => setTimeout(play));
    let x0 = null;
    hero.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', e => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 50) go(cur + (dx < 0 ? 1 : -1)); x0 = null; });
    if ('IntersectionObserver' in window) new IntersectionObserver(([e]) => { visible = e.isIntersecting; play(); }).observe(hero);
    hero.ppGo = go;
    go(pin > 0 && pin <= slides.length ? pin - 1 : 0);
  };

  /* ---------- product page ---------- */
  const product = root => {
    if (root.dataset.ready) return; root.dataset.ready = 1;
    const dataEl = $('script[data-product-json]', root); if (!dataEl) return;
    const D = JSON.parse(dataEl.textContent);
    const V = D.variants; let vi = Math.max(0, V.findIndex(v => v.id === D.selected)); let q = 1;
    const form = $('form.js-add-form', root), idIn = form && $('[name=id]', form), qIn = form && $('[name=quantity]', form);
    const addBtn = $('.js-add', root), addPrice = $('.js-add-price', root);
    const sticky = $('.sticky', root) || $('#sticky');
    /* Offer, shades-on-skin etc. are separate sections, so variant updates reach the whole page */
    const page = root.closest('main') || document;

    /* gallery */
    const stage = $('.js-stage', root), thumbs = $$('.thumbs button', root), idx = $('.thumbs .idx', root);
    let gi = 0;
    const show = i => {
      if (!thumbs.length) return;
      gi = (i + thumbs.length) % thumbs.length;
      const b = thumbs[gi];
      if (stage) {
        stage.style.animation = 'none'; void stage.offsetWidth; stage.style.animation = '';
        stage.srcset = b.dataset.srcset || ''; stage.src = b.dataset.src; stage.alt = b.dataset.alt || '';
      }
      if (idx) idx.textContent = `${pad(gi + 1)} / ${pad(thumbs.length)}`;
      thumbs.forEach((t, k) => t.setAttribute('aria-current', k === gi));
    };
    thumbs.forEach((b, i) => b.addEventListener('click', () => show(i)));
    if (thumbs.length) show(0);

    /* detail tabs */
    const tb = $$('.tabs [role=tab]', root), panes = $$('[data-tab-pane]', root);
    const tab = i => { tb.forEach((b, k) => b.setAttribute('aria-selected', k === i)); panes.forEach((p, k) => { p.hidden = k !== i; }); };
    tb.forEach((b, i) => b.addEventListener('click', () => tab(i)));
    if (tb.length) tab(0);

    /* stock + dispatch */
    const stock = $('.js-stock', root);
    const stockLine = v => {
      if (!stock) return;
      const n = v.inv, name = esc(v.shade), tracked = v.managed && v.policy !== 'continue';
      stock.classList.toggle('low', v.available && tracked && n > 0 && n <= 10);
      stock.innerHTML = !v.available ? `<i class="pulse"></i><span><b>Sold out</b>${name ? ' in ' + name : ''}</span>`
        : tracked && n > 0 && n <= 10 ? `<i class="pulse"></i><span>Only <b>${n} left</b>${name ? ' in ' + name : ''}</span><span class="meter"><i style="width:${n * 10}%"></i></span>`
        : `<i class="pulse"></i><span><b>In stock</b>${name ? ' in ' + name : ''}</span>`;
    };
    const ship = $('.js-ship', root);
    const shipLine = () => {
      if (!ship) return;
      const ist = new Date(Date.now() + 330 * 6e4), day = ist.getUTCDay(), mins = ist.getUTCHours() * 60 + ist.getUTCMinutes();
      const left = (S.cutoff || 14) * 60 - mins, today = day !== 0 && left > 0;
      const next = day === 0 || day === 6 ? 'Monday' : 'tomorrow';
      ship.innerHTML = `<svg class="ic" aria-hidden="true"><use href="#i-truck"/></svg><span>` + (today
        ? `Order within <b>${Math.floor(left / 60) ? Math.floor(left / 60) + 'h ' : ''}${left % 60}m</b> and it ships <b>today</b>`
        : `Order now and it ships <b>${next}</b>`) + `</span>`;
    };
    shipLine(); setInterval(shipLine, 30000);

    /* offer countdown: product metafield custom.offer_ends */
    const deal = $('.deal', root), cd = $('.cd', root), stDeal = $('.js-st-deal', root);
    const ends = D.offerEnds ? new Date(D.offerEnds) : null;
    const tick = () => {
      const v = V[vi], ms = ends ? ends - Date.now() : 0;
      if (!(ms > 0) || !(v.compare > v.price)) { if (deal) deal.hidden = true; if (stDeal) stDeal.textContent = ''; return false; }
      const d = Math.floor(ms / 864e5), hr = Math.floor(ms / 36e5) % 24, mn = Math.floor(ms / 6e4) % 60, sc = Math.floor(ms / 1e3) % 60;
      if (deal) deal.hidden = false;
      const dp = $('.js-deal-pct', root); if (dp) dp.textContent = `${Math.round((v.compare - v.price) * 100 / v.compare)}% off`;
      if (cd) cd.innerHTML = [[d, 'days'], [hr, 'hrs'], [mn, 'min'], [sc, 'sec']].map(([x, l]) => `<span><b>${pad(x)}</b><small>${l}</small></span>`).join('');
      if (stDeal) stDeal.textContent = ` · Offer ends in ${d ? d + 'd ' : ''}${hr}h ${mn}m`;
      return true;
    };
    if (tick()) setInterval(tick, 1000);

    /* free-gift meter */
    const gift = $('.js-gift', root);
    let cartTotal = null, inBag = false;
    const drawGift = () => {
      if (!gift || cartTotal === null) return;
      const v = V[vi], sub = cartTotal + (inBag ? 0 : v.price * q), rem = (S.gift || 149900) - sub;
      gift.classList.toggle('done', rem <= 0);
      const bar = $('.meter i', gift); if (bar) bar.style.width = `${Math.min(100, sub / (S.gift || 149900) * 100)}%`;
      const txt = $('.js-gift-txt', gift);
      if (txt) txt.innerHTML = rem <= 0 ? `<b>Free gift unlocked.</b> Your order is over ${money(S.gift)}.`
        : `Add <b>${money(rem)}</b> more for a <b>free gift</b>${inBag ? '' : ' (with this in your bag)'}`;
    };
    const readCart = c => { cartTotal = c.total_price; inBag = c.items.some(i => i.product_id === D.id); drawGift(); };
    document.addEventListener('pp:cart', e => readCart(e.detail));
    cartJSON().then(readCart).catch(() => {});

    /* variant pick */
    const sw = $$('.sw [role=radio]', root);
    const pick = (i, jump = true) => {
      vi = i; const v = V[vi];
      if (idIn) idIn.value = v.id;
      const sn = $('.js-shade-name', root); if (sn) sn.textContent = v.shade;
      sw.forEach((b, k) => { b.setAttribute('aria-checked', k === vi); b.tabIndex = k === vi ? 0 : -1; });
      if (jump && v.media != null) { const k = thumbs.findIndex(t => +t.dataset.mediaId === v.media); if (k > -1) show(k); }
      const set = (sel, val, html) => $$(sel, page).forEach(el => { if (html) el.innerHTML = val; else el.textContent = val; });
      set('.js-price', money(v.price));
      set('.js-mrp', v.compare > v.price ? money(v.compare) : '');
      set('.js-pct', v.compare > v.price ? Math.round((v.compare - v.price) * 100 / v.compare) + '% off' : '');
      set('.js-st-shade', v.shade);
      set('.js-h-shade', v.shade);
      set('.js-st-price', money(v.price));
      $$('.js-st-dot', page).forEach(el => el.style.setProperty('--c', v.color));
      const online = Math.round(v.price * (100 - (S.prepaid || 0)) / 100);
      set('.js-of-price', money(online));
      set('.js-of-mrp', v.compare > online ? money(v.compare || v.price) : '');
      set('.js-of-save', `Paid online. You save ${money((v.compare > v.price ? v.compare : v.price) - online)}${v.compare > v.price ? ' on MRP' : ''}.`);
      $$('[data-variant-add]', page).forEach(b => { b.dataset.addVariant = v.id; b.setAttribute('aria-disabled', !v.available); });
      if (addBtn) {
        addBtn.disabled = !v.available;
        const lbl = $('.js-add-label', addBtn); if (lbl) lbl.textContent = v.available ? 'Add to bag' : 'Sold out';
      }
      stockLine(v); setQ(q); tick();
      if (jump && D.updateUrl !== false && history.replaceState) {
        const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
      }
    };
    sw.forEach((b, i) => {
      b.addEventListener('click', () => pick(i));
      b.addEventListener('keydown', e => {
        const d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
        if (d) { e.preventDefault(); const n = (vi + d + sw.length) % sw.length; pick(n); sw[n].focus(); }
      });
    });
    $$('[data-pick]', page).forEach(b => b.addEventListener('click', () => {
      const i = V.findIndex(v => v.id === +b.dataset.pick); if (i < 0) return;
      pick(i); root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }));
    function setQ(n) {
      q = Math.max(1, Math.min(10, n));
      const qv = $('.js-qv', root); if (qv) qv.textContent = q;
      if (qIn) qIn.value = q;
      if (addPrice) addPrice.textContent = money(V[vi].price * q);
      drawGift();
    }
    const qm = $('.js-qm', root), qp = $('.js-qp', root);
    if (qm) qm.addEventListener('click', () => setQ(q - 1));
    if (qp) qp.addEventListener('click', () => setQ(q + 1));
    pick(vi, false);

    /* Buy it now: Shiprocket checkout for this variant + quantity (it reads the form's id/quantity inputs), else a cart permalink */
    const now = $('.js-buy-now', root);
    if (now) now.addEventListener('click', e => {
      e.preventDefault();
      if (window.shiprocketCheckoutEvents && now.closest('form')) { window.shiprocketCheckoutEvents.buyProduct(e); return; }
      location.href = `${R.root.replace(/\/?$/, '/')}cart/${V[vi].id}:${q}`;
    });

    /* pincode estimate (stub: uses theme settings, not a courier API) */
    const pf = $('.js-pin-form', root);
    if (pf) pf.addEventListener('submit', e => {
      e.preventDefault();
      const v = $('input', pf).value.trim(), out = $('.js-pin-out', root);
      const metro = (S.metro || []).some(p => p && v.startsWith(String(p).trim()));
      const d = new Date(); d.setDate(d.getDate() + (metro ? S.metroDays || 3 : S.otherDays || 5));
      out.innerHTML = /^\d{6}$/.test(v) ? `Delivers by <b>${d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' })}</b> · COD available` : 'Enter a valid 6-digit pincode.';
    });

    /* sticky bar */
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      const stAdd = $('button', sticky);
      new IntersectionObserver(([e]) => {
        const on = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('on', on); sticky.setAttribute('aria-hidden', !on);
        if (stAdd) stAdd.tabIndex = on ? 0 : -1;
        document.body.classList.toggle('has-sticky', on);
      }).observe(addBtn);
    }
  };

  /* ---------- product videos: click to load ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-vid]'); if (!b) return;
    const tpl = b.querySelector('template'); if (!tpl) return;
    e.preventDefault();
    const box = document.createElement('div'); box.className = 'vid vid-live';
    box.appendChild(tpl.content.cloneNode(true)); b.replaceWith(box);
    const v = box.querySelector('video'); if (v) v.play().catch(() => {});
  });

  /* ---------- review chips (static review blocks carry data-stars / data-sensitive) ---------- */
  const reviewChips = root => $$('[data-rf]', root).forEach(b => b.addEventListener('click', () => {
    const f = b.dataset.rf, list = $$('.rev', root);
    $$('[data-rf]', root).forEach(y => y.setAttribute('aria-pressed', y === b));
    list.forEach(r => { r.hidden = !(f === 'all' || (f === '5' ? r.dataset.stars === '5' : r.dataset.sensitive === 'true')); });
  }));

  /* ---------- collection sort ---------- */
  document.addEventListener('change', e => {
    const s = e.target.closest('select[data-sort]'); if (!s) return;
    const u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u;
  });

  /* ---------- cart discount code: Shopify stores it and applies it at checkout ---------- */
  const applyCode = box => {
    const c = box.querySelector('input').value.trim(); if (!c) return;
    location.href = '/discount/' + encodeURIComponent(c) + '?redirect=' + encodeURIComponent(location.pathname);
  };
  document.addEventListener('click', e => { const b = e.target.closest('[data-coupon] button'); if (b) applyCode(b.closest('[data-coupon]')); });
  document.addEventListener('keydown', e => {
    if (e.key !== 'Enter') return; const box = e.target.closest('[data-coupon]'); if (!box) return;
    e.preventDefault(); applyCode(box);
  });

  /* ---------- search result tabs ---------- */
  const searchTabs = root => $$('.s-tabs', root).forEach(list => {
    const bs = $$('button', list);
    bs.forEach(b => b.addEventListener('click', () => {
      bs.forEach(o => o.setAttribute('aria-selected', o === b));
      $$('[data-view]', root).forEach(p => { p.hidden = p.dataset.view !== b.dataset.v; });
    }));
  });

  /* ---------- FAQ page: live filter + nav highlight ---------- */
  const faqPage = root => {
    const input = $('.js-faq-q', root); const groups = $$('.grp', root); const none = $('.js-faq-none', root);
    const orig = new Map();
    $$('details.qa', root).forEach(d => orig.set(d, { s: $('summary .qt', d) ? $('summary .qt', d).innerHTML : '', p: $('.qa-a', d) ? $('.qa-a', d).innerHTML : '', open: d.open }));
    const hlHTML = (s, rx) => s.replace(/(<[^>]+>)|([^<]+)/g, (m, tag, txt) => tag || txt.replace(rx, '<mark>$1</mark>'));
    if (input) input.addEventListener('input', () => {
      const q = input.value.trim(); const rx = q ? new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi') : null;
      let n = 0;
      groups.forEach(g => {
        let k = 0;
        $$('details.qa', g).forEach(d => {
          const o = orig.get(d), qt = $('summary .qt', d), a = $('.qa-a', d);
          const hit = !rx || (o.s + ' ' + o.p).replace(/<[^>]+>/g, ' ').match(rx);
          d.hidden = !hit; if (hit) k++;
          if (qt) qt.innerHTML = rx ? hlHTML(o.s, rx) : o.s;
          if (a) a.innerHTML = rx ? hlHTML(o.p, rx) : o.p;
          d.open = rx ? !!hit : o.open;
        });
        g.hidden = !k; n += k;
      });
      if (none) { none.hidden = n > 0; const w = $('.js-faq-term', none); if (w) w.textContent = q; }
    });
    const links = $$('.faq-nav a, #nav a', root);
    if (links.length && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) links.forEach(a => a.classList.toggle('on', a.hash === '#' + e.target.id)); }), { rootMargin: '-30% 0px -60% 0px' });
      groups.forEach(g => io.observe(g));
    }
  };

  /* ---------- lab reports: grid/table switch, pins, full-size viewer ---------- */
  const labPage = root => {
    $$('.seg button', root).forEach(b => b.addEventListener('click', () => {
      $$('.seg button', root).forEach(o => o.setAttribute('aria-pressed', o === b));
      const t = b.dataset.mode === 'table';
      const reps = $('.js-reps', root), tbl = $('.js-tbl', root);
      if (reps) reps.hidden = t; if (tbl) tbl.hidden = !t;
    }));
  };
  const labAnno = root => {
    const anno = $('.js-anno', root); if (!anno) return;
    $$('.js-legend li', root).forEach((li, n) => {
      const p = document.createElement('span'); p.className = 'pin'; p.textContent = n + 1; p.setAttribute('aria-hidden', 'true');
      p.style.left = li.dataset.x + '%'; p.style.top = li.dataset.y + '%'; anno.appendChild(p);
      const on = v => { li.classList.toggle('on', v); p.classList.toggle('on', v); };
      [li, p].forEach(el => { el.addEventListener('mouseenter', () => on(true)); el.addEventListener('mouseleave', () => on(false)); });
    });
  };
  /* The viewer reads every [data-cert-view] on the page: data-full, data-pdf, data-name, data-meta, data-key */
  const viewer = () => {
    const srcs = []; const seen = new Set();
    $$('[data-cert-view]').forEach(b => { if (!seen.has(b.dataset.key)) { seen.add(b.dataset.key); srcs.push(b); } });
    if (!srcs.length) return;
    let v = null, from = null, at = 0;
    const shut = () => { if (!v) return; v.remove(); v = null; document.body.style.overflow = ''; if (from) from.focus(); };
    const show = i => {
      at = (i + srcs.length) % srcs.length; const r = srcs[at].dataset;
      v.setAttribute('aria-label', r.name + ' certificate');
      $('.vt b', v).textContent = r.name; $('.vt small', v).textContent = r.meta || '';
      const pdf = $('[data-pdf]', v); pdf.hidden = !r.pdf; if (r.pdf) pdf.href = r.pdf;
      const pane = $('.pane', v); pane.classList.remove('z');
      const img = $('img', pane); img.src = r.full; img.alt = `${r.name} safety evaluation certificate`;
      $('.vb span', v).textContent = `${at + 1} / ${srcs.length}`;
    };
    const openV = i => {
      v = document.createElement('div'); v.className = 'viewer'; v.setAttribute('role', 'dialog'); v.setAttribute('aria-modal', 'true');
      v.innerHTML = `<div class="vt"><div><small></small><b></b></div><div class="acts"><a class="btn btn-cream" data-pdf target="_blank" rel="noopener">Download PDF</a><button type="button" class="circ" data-x aria-label="Close"><svg><use href="#i-close"/></svg></button></div></div>
        <div class="mid"><button type="button" class="circ" data-go="-1" aria-label="Previous certificate"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M15 5l-7 7 7 7"/></svg></button><div class="pane"><img alt="" width="2000" height="1269"></div><button type="button" class="circ" data-go="1" aria-label="Next certificate"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M9 5l7 7-7 7"/></svg></button></div>
        <div class="vb"><span></span><span>Click the certificate to zoom</span></div>`;
      document.body.appendChild(v); document.body.style.overflow = 'hidden'; show(i);
      const pane = $('.pane', v);
      $('img', pane).addEventListener('click', e => {
        const img = e.currentTarget, rc = img.getBoundingClientRect(), fx = (e.clientX - rc.left) / rc.width, fy = (e.clientY - rc.top) / rc.height;
        if (pane.classList.toggle('z')) { pane.scrollLeft = img.offsetWidth * fx - pane.clientWidth / 2; pane.scrollTop = img.offsetHeight * fy - pane.clientHeight / 2; }
      });
      v.addEventListener('click', e => {
        const g = e.target.closest('[data-go]'); if (g) return show(at + +g.dataset.go);
        if (e.target.closest('[data-x]') || e.target === v || e.target.classList.contains('mid') || e.target === pane) shut();
      });
      $('[data-x]', v).focus();
    };
    document.addEventListener('click', e => {
      const b = e.target.closest('[data-cert-view]'); if (!b) return;
      e.preventDefault(); from = b; openV(srcs.findIndex(s => s.dataset.key === b.dataset.key));
    });
    document.addEventListener('keydown', e => {
      if (!v) return;
      if (e.key === 'Escape') shut(); else if (e.key === 'ArrowRight') show(at + 1); else if (e.key === 'ArrowLeft') show(at - 1);
    });
    const want = new URLSearchParams(location.search).get('view');
    if (want && document.body.classList.contains('tpl-page-lab-reports')) {
      const i = srcs.findIndex(s => s.dataset.key === want); if (i > -1) { from = srcs[i]; openV(i); }
    }
  };

  /* ---------- ingredients glossary: role filter ---------- */
  const ingredients = root => {
    const bs = $$('[data-r]', root); if (!bs.length) return;
    const setRole = x => {
      bs.forEach(b => b.setAttribute('aria-pressed', b.dataset.r === x));
      $$('.g[data-role]', root).forEach(g => { g.hidden = !(x === 'All' || g.dataset.role === x); });
    };
    bs.forEach(b => b.addEventListener('click', () => setRole(b.dataset.r)));
    document.addEventListener('click', e => { if (e.target.closest('[data-jump]')) setRole('All'); });
  };

  /* ---------- article: share + table of contents ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-share]'); if (!b) return;
    e.preventDefault();
    const url = b.dataset.url || location.href;
    if (navigator.share && b.dataset.native !== 'false') { navigator.share({ title: document.title, url }).catch(() => {}); return; }
    try { navigator.clipboard.writeText(url); } catch (err) {}
    say('Link copied');
  });
  const toc = root => {
    const links = $$('.js-toc a', root);
    if (!links.length || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) links.forEach(a => a.classList.toggle('on', a.hash === '#' + e.target.id)); }), { rootMargin: '-30% 0px -60% 0px' });
    links.forEach(a => { const t = document.getElementById(decodeURIComponent(a.hash.slice(1))); if (t) io.observe(t); });
  };
  /* Build a TOC from the article body's h2s when the section asks for one */
  const autoToc = root => {
    const box = $('.js-toc[data-auto]', root), body = $('.rte', root);
    if (!box || !body) return;
    const hs = $$('h2', body); if (hs.length < 2) { const wrap = box.closest('.toc-wrap') || box; wrap.hidden = true; return; }
    box.innerHTML = hs.map((h, i) => { if (!h.id) h.id = 's' + (i + 1); return `<a href="#${h.id}">${esc(h.textContent)}</a>`; }).join('');
  };

  /* ---------- policies: highlight the nav link for the section in view ---------- */
  const policyNav = root => {
    const links = $$('.pol-nav a', root);
    if (!links.length || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(es => es.forEach(e => {
      if (!e.isIntersecting) return;
      links.forEach(a => {
        const on = a.hash === '#' + e.target.id; a.classList.toggle('on', on);
        if (on && innerWidth < 900) a.parentNode.scrollTo({ left: a.offsetLeft - 20, behavior: 'smooth' });
      });
    }), { rootMargin: '-30% 0px -60% 0px' });
    $$('.doc > section', root).forEach(s => io.observe(s));
  };

  /* ---------- init, and re-init inside the theme editor ---------- */
  /* ---------- product recommendations: fetched after load ---------- */
  const recs = el => {
    if (el.dataset.done) return; el.dataset.done = '1';
    fetch(el.dataset.url).then(r => r.text()).then(t => {
      const d = new DOMParser().parseFromString(t, 'text/html'), n = d.querySelector('[data-recs]');
      if (n && n.querySelector('.pgrid > *')) el.innerHTML = n.innerHTML; else el.hidden = true;
    }).catch(() => { el.hidden = true; });
  };
  /* ---------- offer timer: Theme settings > Offer timer, shared by the announcement bar and the product offer box ---------- */
  const T = S.timer || {};
  const offerEnd = () => {
    if (T.mode === 'date' && T.end) {
      const m = String(T.end).match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?/);
      return m ? Date.parse(`${m[1]}-${m[2]}-${m[3]}T${pad(m[4] || 23)}:${m[5] || '59'}:00+05:30`) : NaN;
    }
    if (T.mode === 'rolling') {
      /* same window for every visitor: fixed-length slots counted from midnight IST, 1 Jan 2026 */
      const p = (T.hours || 48) * 36e5, a = Date.parse('2026-01-01T00:00:00+05:30');
      return a + (Math.floor((Date.now() - a) / p) + 1) * p;
    }
    return NaN;
  };
  const offerTick = () => {
    const ms = offerEnd() - Date.now(), on = ms > 0;
    const h = Math.floor(ms / 36e5), mn = Math.floor(ms / 6e4) % 60, sc = Math.floor(ms / 1e3) % 60;
    const txt = h >= 72 ? `${Math.floor(h / 24)}d ${h % 24}h ${pad(mn)}m` : `${h}h ${pad(mn)}m ${pad(sc)}s`;
    $$('[data-offer-timer]').forEach(el => {
      el.hidden = !on;
      const out = $('.js-ot', el); if (on && out) out.textContent = txt;
    });
  };
  if (T.mode && T.mode !== 'off') setInterval(offerTick, 1000);

  /* ---------- announcement bar: one message at a time ---------- */
  const annBar = el => {
    if (el.dataset.ready) return; el.dataset.ready = 1;
    const msgs = $$('.ab-msg', el); if (msgs.length < 2) return;
    let i = 0;
    const go = n => { i = (n + msgs.length) % msgs.length; msgs.forEach((m, k) => { m.classList.toggle('on', k === i); m.setAttribute('aria-hidden', k !== i); }); };
    let t = setInterval(() => go(i + 1), (+el.dataset.ab || 4) * 1000);
    el.addEventListener('mouseenter', () => clearInterval(t));
    el.addEventListener('mouseleave', () => { clearInterval(t); t = setInterval(() => go(i + 1), (+el.dataset.ab || 4) * 1000); });
    $$('.ab-arw', el).forEach(b => b.addEventListener('click', () => go(i + +b.dataset.d)));
  };
  const init = (root = document) => {
    $$('[data-ab]', root).forEach(annBar);
    if (T.mode && T.mode !== 'off') offerTick();
    $$('[data-recs-load]', root).forEach(recs);
    $$('[data-slideshow]', root).forEach(slideshow);
    $$('[data-product-root]', root).forEach(product);
    tabs(root); certs(root); reviewChips(root); searchTabs(root);
    $$('[data-faq-page]', root).forEach(faqPage);
    $$('[data-lab-page]', root).forEach(labPage);
    labAnno(root);
    $$('[data-ingredients]', root).forEach(ingredients);
    $$('[data-article]', root).forEach(r => { autoToc(r); toc(r); });
    $$('[data-policies]', root).forEach(policyNav);
  };
  const boot = () => { initHeader(); init(); viewer(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  document.addEventListener('shopify:section:load', e => { init(e.target); certs(e.target); });
  document.addEventListener('shopify:block:select', e => {
    const slide = e.target.closest('.slide'), hero = slide && slide.closest('[data-slideshow]');
    if (hero && hero.ppGo) hero.ppGo($$('.slide', hero).indexOf(slide));
    const d = e.target.closest('details'); if (d) d.open = true;
  });

  window.PP = Object.assign(window.PP || {}, { money, say, addItem, openDrawer, certs });
})();
